import { type LinkProps } from 'next/link';

import styles from './account-badge.module.css';
import { useContent } from '../../top-navigation.context';
import { Link } from '../link/link';
import { Popover } from '../popover/popover';

type AccountBadgeProps = {
  onLogout: VoidFunction;
  accountHref: LinkProps['href'];
  user: {
    firstName: string;
    lastName: string;
  };
};
export const AccountBadge = ({ onLogout, accountHref, user: { firstName, lastName } }: AccountBadgeProps) => {
  const { profile, logout } = useContent();

  return (
    <Popover trigger={<button className={styles.trigger}>{firstName[0]?.toUpperCase()}</button>} offset={6}>
      <Popover.List title={`${firstName} ${lastName}`}>
        <Popover.ListItem>
          <Link href={accountHref}>{profile}</Link>
        </Popover.ListItem>

        <Popover.ListItem>
          <Popover.Close>
            <Link onClick={onLogout}>{logout}</Link>
          </Popover.Close>
        </Popover.ListItem>
      </Popover.List>
    </Popover>
  );
};
